// Example from the official documentation at
// https://www.npmjs.com/package/vue-toasted#custom-toast-registration

/* Example of use
    this.$toasted.global.pixError({ message: 'lorem ipsum dolor sit amet' })
    this.$toasted.global.pixWarning({ message: 'lorem ipsum dolor sit amet' })
    this.$toasted.global.pixSuccess({ message: 'lorem ipsum dolor sit amet' })
    this.$toasted.global.pixInfo({ message: 'lorem ipsum dolor sit amet' })

    this.$toasted.global.pixError('lorem ipsum dolor sit amet')
    this.$toasted.global.pixWarning('lorem ipsum dolor sit amet')
    this.$toasted.global.pixSuccess('lorem ipsum dolor sit amet')
    this.$toasted.global.pixInfo('lorem ipsum dolor sit amet')

    use 'this.' inside a Vue component or instead use `Vue.`
*/

const customToastConfigurations = [
  {
    name: 'pixError',
    options: {
      type: 'error',
      icon: 'mdi-alert-octagram',
      className: ['toasted-pixError'],
    },
    callback: (payload) => {
      return payload.message ?? payload ?? 'Error';
    },
  },
  {
    name: 'pixWarning',
    options: {
      type: 'error',
      icon: 'mdi-alert-rhombus',
      className: ['toasted-pixWarning'],
    },
    callback: (payload) => {
      return payload.message ?? payload ?? 'Warning';
    },
  },
  {
    name: 'pixInfo',
    options: {
      type: 'error',
      icon: 'mdi-information',
      className: ['toasted-pixInfo'],
    },
    callback: (payload) => {
      return payload.message ?? payload ?? 'Info';
    },
  },
  {
    name: 'pixSuccess',
    options: {
      type: 'error',
      icon: 'mdi-check-circle',
      className: ['toasted-pixSuccess'],
    },
    callback: (payload) => {
      return payload.message ?? payload ?? 'Success';
    },
  },
];

const registerCustomToasts = (vueToastedRegisterFunction) => {
  customToastConfigurations.forEach((config) => {
    vueToastedRegisterFunction(config.name, config.callback, config.options);
  });
};

export default {
  registerCustomToasts,
};
